export const ActivityType = Object.freeze({
  documents: 0,
  profile: 1,
  fundingMatch: 2,
  feedback: 3,
});

export const ActivityTypeLabel = Object.freeze({
  [ActivityType.documents]: 'Documents',
  [ActivityType.profile]: 'Profile',
  [ActivityType.fundingMatch]: 'Funding Match',
  [ActivityType.feedback]: 'Feedback',
  FUNDING: 'Funding',
  ['NON-FUNDING']: 'Non-funding',
  CREDIT_IMPROVEMENT: 'Credit Improvement',
});

export const UpdateType = Object.freeze({
  application: 'application',
  article: 'article',
});

export function isValid(type) {
  return Object.values(ActivityType).find((elem) => elem === type);
}
